var map = {
	"./testimonial1.jpg": 2514,
	"./testimonial10.jpg": 1760,
	"./testimonial11.jpg": 8861,
	"./testimonial12.jpg": 6722,
	"./testimonial13.jpg": 6719,
	"./testimonial14.jpg": 4756,
	"./testimonial15.jpg": 3281,
	"./testimonial16.jpg": 1862,
	"./testimonial17.jpg": 6563,
	"./testimonial18.jpg": 3832,
	"./testimonial19.jpg": 1093,
	"./testimonial2.jpg": 1741,
	"./testimonial20.jpg": 6561,
	"./testimonial21.jpg": 8516,
	"./testimonial22.jpg": 6323,
	"./testimonial23.jpg": 9862,
	"./testimonial24.jpg": 973,
	"./testimonial25.jpg": 9840,
	"./testimonial26.jpg": 3455,
	"./testimonial27.jpg": 1074,
	"./testimonial28.jpg": 3433,
	"./testimonial29.jpg": 1740,
	"./testimonial3.jpg": 6848,
	"./testimonial30.jpg": 9466,
	"./testimonial31.jpg": 855,
	"./testimonial4.jpg": 5651,
	"./testimonial5.jpg": 1894,
	"./testimonial6.jpg": 7745,
	"./testimonial7.jpg": 5940,
	"./testimonial8.jpg": 4375,
	"./testimonial9.jpg": 6634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4545;